import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { ProductModuleBody } from "types/api/productModule";

function useProductModuleApi() {
    const { del, post, put } = useHttpManaged();
    const createProductModule = React.useCallback((body: ProductModuleBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, ProductModuleBody, ResponseWithId>({
            url: "/product-module",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateProductModule = React.useCallback((pathParams: PathParamsWithId, body: ProductModuleBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, ProductModuleBody, null>({
            url: "/product-module/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteProductModule = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/product-module/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        createProductModule,
        updateProductModule,
        deleteProductModule
    };
}

export default useProductModuleApi;